import type { RouteRecordRaw } from 'vue-router'

// 添加设备绑定流程
export const bindDeviceRoutes: RouteRecordRaw[] = [
  {
    // 选择孩子子账号
    path: '/bind-device/choose-master',
    name: 'bind-device-choose-master',
    component: () => import('@/pages/BindDevice/ChooseMaster/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 4G 设备配对码输入
    path: '/bind-device/network-4g',
    name: 'bind-device-network-4g',
    component: () => import('@/pages/BindDevice/Network4G/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 绑定成功操作指引
    path: '/bind-device/operation-guide',
    name: 'bind-device-operation-guide',
    component: () => import('@/pages/BindDevice/OperationGuide/index.vue'),
    meta: { backMode: 'block' },
  },
  {
    // 设备绑定后选择对话语言
    path: '/bind-device/set-language',
    name: 'bind-device-set-language',
    component: () => import('@/pages/BindDevice/SetLanguage/index.vue'),
    meta: { backMode: 'block' },
  },
]
